import React from "react";

export const FacebookIcon = ({
  width = "9.528",
  height = "19.056",
  fill = "#fff",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9.528 19.056"
      {...{ width, height, fill }}
    >
      <path
        id="Forma_1"
        data-name="Forma 1"
        d="M1248.054,5655.847v-2.382a1.191,1.191,0,0,1,1.191-1.191h1.191V5649.3h-2.382a3.573,3.573,0,0,0-3.573,3.573v2.978H1242.1v2.978h2.382v9.528h3.573v-9.528h2.382l1.191-2.978Z"
        transform="translate(-1242.099 -5649.297)"
      />
    </svg>
  );
};
